"use client";
import styled, { keyframes } from "styled-components";
import { css } from "styled-components";

const STRIPE_WIDTH = "110px";
const animateButtonPendingBackground = keyframes`
  0% {
		transform: translateX(-${STRIPE_WIDTH});
	}
	100% {
		transform: translateX(0);
	}
`;

const DefaultButton = styled.div<{ pendingClickable?: boolean }>`
  background: var(--fill-primary);
  border-radius: 16px;
  justify-content: center;
  height: 64px;
  padding: 20px;
  overflow: hidden;
  isolation: isolate;
  border: 0;
  box-shadow: 0 0 0;
  outline: 0;
  color: var(--text-invert-primary);
  cursor: pointer;

  transition: 300ms ease-out;

  &:hover {
    background: var(--fill-primary-hover);
  }

  &:active {
    transform: scale(0.95);
  }

  .action__title {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: 0.02em;
    font-variation-settings: "wght" 700;
  }
  .action__subinfo {
    letter-spacing: 0.5px;
    font-size: 12px;
    line-height: 16px;
    font-variation-settings: "wght" 500, "ital" 1;
    font-style: italic;
    color: #99ffee;
  }

  &.disabled {
    pointer-events: none;
    opacity: 0.3;
  }

  .pending-div {
    position: absolute;
  }

  &.pending {
    position: relative;
    ${(props) =>
      props.pendingClickable
        ? ""
        : css`
            pointer-events: none;
          `}
    .pending-div {
      top: 0;
      left: 0;
      height: 100%;
      width: calc(100% + ${STRIPE_WIDTH});
      background: repeating-linear-gradient(
        45deg,
        var(--background-secondary) 25%,
        var(--background-secondary) 50%,
        var(--background-elevated) 50%,
        var(--background-elevated) 75%
      );

      background-size: ${STRIPE_WIDTH} ${STRIPE_WIDTH};
      animation: ${animateButtonPendingBackground} 2s linear infinite;
    }
  }
`;

export const LendButton = styled(DefaultButton)`
  border-radius: 24px;
  padding: 26px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #fff;
  overflow: hidden;
  isolation: isolate;
  border: 0;
  height: auto;
  background: var(--fill-primary);
  color: var(--text-invert-primary);

  .action {
    &__title {
      margin-bottom: 4px;
      justify-content: flex-start;
    }
    &__subinfo {
      letter-spacing: 0.5px;
      font-size: 12px;
      line-height: 16px;
      font-variation-settings: "wght" 500, "ital" 1;
      font-style: italic;
      color: var(--text-accent);
      text-align: left;
    }
  }
`;

export const Title = styled.div`
  font-size: 32px;
  line-height: 48px;
  font-variation-settings: "wght" 700;
  letter-spacing: 0.32px;
  @media (min-width: 1024px) {
    font-size: 40px;
  }
`;

export const CoinGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  @media (min-width: 768px) {
    gap: 24px;
  }
`;
